import { useCallback, useEffect, useState } from 'react';
import { formatImageUrl } from '../../shared/utils/formatImageUrl';
import { UploadPicture } from '../UploadPicture/index.js';
import { ConfirmModal } from '../../shared/ui/ConfirmModal';

export const AddAdditionalPictures = ({ values, onAdd, onDelete }) => {
  const [addedItems, setAddedItems] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);

  const handleAdd = (value) => {
    // Вызываем функцию добавления из родительского компонента
    onAdd && onAdd(value);
    // Не обновляем здесь addedItems, так как это делается через пропс values
  };

  // Открытие модального окна подтверждения удаления
  const confirmDelete = (value) => {
    setImageToDelete(value);
    setShowConfirmModal(true);
  };
  
  // Удаление после подтверждения
  const handleDelete = () => {
    if (!imageToDelete) return;
    
    // Вызываем функцию удаления из родительского компонента
    onDelete && onDelete(imageToDelete);
    
    // Не обновляем здесь addedItems, так как это делается через пропс values
    // Обновление происходит в родительском компоненте и передается через props
    
    // Сбрасываем выбранное изображение
    setImageToDelete(null);
  };

  const formatImageUrl = useCallback((path) => {
    if (path) return `${import.meta.env.VITE_API_URL}${path}`;
    return '';
  }, []);

  const getPictureFromBlob = useCallback((value) => {
    try {
      // Если значение отсутствует или null
      if (!value) {
        return '';
      }
      
      // Если значение - объект с imgPath
      if (typeof value === 'object' && value.imgPath) {
        return formatImageUrl(value.imgPath);
      } 
      
      // Если это временное изображение с id и свойством file
      if (typeof value === 'object' && value.id && typeof value.id === 'string' && value.id.startsWith('temp_')) {
        if (value.file && (value.file instanceof Blob || value.file instanceof File)) {
          return URL.createObjectURL(value.file);
        }
        // Если есть превью URL
        if (value.previewUrl) {
          return value.previewUrl;
        }
        // Если есть свойство blob
        if (value.blob) {
          return value.blob;
        }
      }
      
      // Если значение - объект с name и type (загруженный файл)
      if (typeof value === 'object' && value.name && value.type && value.type.startsWith('image/')) {
        if (value instanceof Blob || value instanceof File) {
          return URL.createObjectURL(value);
        }
      }
      
      // Если значение - строка, возвращаем её как есть (предполагая, что это URL или путь)
      if (typeof value === 'string') {
        // Если это полный URL
        if (value.startsWith('http') || value.startsWith('data:')) {
          return value;
        }
        // Если это путь к изображению на сервере
        return formatImageUrl(value);
      }
      
      // В других случаях возвращаем заглушку
      console.warn('Неизвестный тип изображения:', value);
      return 'https://via.placeholder.com/250x150?text=Изображение';
    } catch (error) {
      console.error('Ошибка при обработке изображения:', error);
      return 'https://via.placeholder.com/250x150?text=Ошибка';
    }
  }, [formatImageUrl]);

  useEffect(() => {
    // Обновляем локальное состояние при изменении props
    if (values !== undefined) setAddedItems(values);
  }, [values]);

  return (
    <div>
      <label className={'form-label'}>Дополнительные изображения</label>
      <div className={'d-flex gap-2 align-items-stretch flex-wrap'}>
        {(values !== undefined ? values : addedItems).length > 0 ? (
          (values !== undefined ? values : addedItems).map((i, index) => (
            <span
              className={'bg-white shadow-sm rounded-4 py-2 px-3 d-flex gap-1 align-items-center'}
              key={i.id || i.name || index}
            >
              {/*<img*/}
              {/*    src={`${typeof i === 'string' ? `${import.meta.env.VITE_API_URL}${i}` : getPictureFromBlob(i)}`}*/}
              {/*    alt=""*/}
              {/*/>*/}
              <div
                style={{
                  backgroundImage: `url('${getPictureFromBlob(i)}')`,
                  width: '250px',
                  height: '150px',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
                className="page-table-image"
              ></div>
              <i
                onClick={() => confirmDelete(i)}
                className="bi bi-x text-danger"
                style={{ cursor: 'pointer' }}
              ></i>
            </span>
          ))
        ) : (
          <p style={{ fontSize: '14px' }}>Отсутствуют добавленные изображения</p>
        )}
      </div>

      <div className={'my-3'}>
        <UploadPicture
          noLabel
          id={'loaded-additional-img-product'}
          textBtn={'Загрузить изображение'}
          noPreview
          onSelect={handleAdd}
        />
      </div>
      
      {/* Модальное окно подтверждения удаления */}
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={handleDelete}
        title="Подтверждение удаления"
        message="Вы уверены, что хотите удалить это изображение?"
        confirmButtonText="Удалить"
        cancelButtonText="Отмена"
        confirmButtonVariant="danger"
      />
    </div>
  );
};
